var _circle, _circle2, _circle3, _circle4, _g, _circle5, _circle6, _circle7, _circle8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "url(#paint0_radial_715_15815)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter0_f_715_15815)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 10,
    fill: "url(#paint1_radial_715_15815)"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9844,
    cy: 15.9844,
    r: 8.98438,
    fill: "url(#paint2_radial_715_15815)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9844,
    cy: 15.9844,
    r: 8.98438,
    fill: "url(#paint3_radial_715_15815)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_715_15815)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.9844,
    cy: 15.9844,
    r: 8.98438,
    fill: "url(#paint4_radial_715_15815)"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0156,
    cy: 15.9844,
    r: 8.73438,
    stroke: "url(#paint5_linear_715_15815)",
    strokeWidth: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 5,
    fill: "url(#paint6_radial_715_15815)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 5,
    fill: "url(#paint7_radial_715_15815)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_715_15815",
    x: 5.5,
    y: 5.5,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_15815"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_715_15815",
    x: 6,
    y: 6,
    width: 19.9688,
    height: 19.9688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_715_15815"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_715_15815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5 7) rotate(114.538) scale(25.2834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71199,
    stopColor: "#DDC3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB87C1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_15815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 16) rotate(90) scale(10)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.743656
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_15815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9844 8.02376) rotate(82.9932) scale(13.6047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.150212,
    stopColor: "#5E1436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967447,
    stopColor: "#984F43"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_15815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9844 26.0625) rotate(-90) scale(19.75 12.5906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#4D0008",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D0008"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_15815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.625 19.3906) rotate(-32.2256) scale(10.3433 5.37097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B78D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967447,
    stopColor: "#B58985",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_15815",
    x1: 9.125,
    y1: 21.625,
    x2: 13.9219,
    y2: 17.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B5347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#510910",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_15815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8246 14.2957) rotate(131.532) scale(6.89981)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2033"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_15815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.774 19.6084) rotate(-54.2456) scale(10.6076 8.47956)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.830959,
    stopColor: "#4B3F40",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B3F40"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.39de62d190c147ad5a0440f75adbb0e0.svg";
export { ForwardRef as ReactComponent };